import { FormProvider } from 'context/FormContext';
import React, { useEffect } from 'react';
import OrganizationSchema from 'schemas/Organization.schema.json';
import DynamicForm, { withExtension } from 'components/Shared/DynamicForm';
import { deepCopy } from 'utils/SchemaUtils';
import { useFormContext } from 'hooks/useFormContext';
import SkeletonForm from 'components/Shared/SkeletonForm';
import { getHiddenProperties } from 'utils/SchemaUtils';
import { addOrganization, updateOrganization } from 'utils/OrganizationUtils';

const Form = ({ defaultValues, CRUDType, orientation, callback }) => {
    const schema = deepCopy(OrganizationSchema);
    const hiddenProperties = getHiddenProperties(schema);

    const formContext = useFormContext();

    useEffect(() => {
        !formContext.ready && formContext.updateSchema(schema);
    }, [formContext, schema]);

    const handleSubmit = async (newData) => {
        let result;
        if(CRUDType === "INSERT") {
            result = await addOrganization(newData);
        } else if (CRUDType === "UPDATE") {
            result = await updateOrganization(newData);
        };
        console.log(result);
        if(result.success) { 
            setTimeout(callback, 1000);
        }
        
        return result;
    };


    return (
        formContext.ready ? withExtension(DynamicForm, {
            schema: formContext.schema,
            defaultValues,
            definitions: formContext.definitions,
            cardElevation: 0,
            orientation,
            hiddenProperties,
            onSubmit: handleSubmit
        })
        : <SkeletonForm ></SkeletonForm>
    )

}

const OrganizationForm = (props) => <FormProvider><Form {...props}></Form></FormProvider>;

export default OrganizationForm;